import date from 'quasar/src/utils/date/date.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { computed, defineComponent, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import MypageBadge from "~/components/MypageBadge.vue";
import { auth } from "~/core/Auth";
import { Log } from "~/extensions/utils";
import { HanyoKb, RoomSb, userType } from "~/extensions/utils/DefineTypes";
import { RoomSelectFindConditionValiator } from "~/pages/common/models/RoomSelectFindConditionValidatr";
import { RoomSelectFindConditionViewModel } from "~/pages/common/models/RoomSelectFindConditionViewModel";
import RoomSelectCard from "~/components/roomSelect/RoomSelectCard.vue";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { RoomSelectViewModel } from "~/pages/common/models/RoomSelectViewModel";
import { isMatchKeyword } from "src/extensions/utils/KeywordSearch";
import { isCurrentlyMovingIn, isMoveIn } from "src/pages/taikyo/Models/RoomSelectHelper";
export default defineComponent({
    components: { RoomSelectCard, MypageBadge },
    name: "RoomSelectArea",
    props: {
        onPush: {
            type: Function,
            required: true
        },
        isTaikyo: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup() {
        const router = useRouter();
        const $q = useQuasar();
        const isMobile = computed(() => $q.screen.lt.md);
        // 部屋選択専用のキャプション文言
        const taikyoCaption = commonStore.messages.PI0021;
        const taikyoParkingCaption = commonStore.messages.PI0022;
        const taikyoMobilCaption = commonStore.messages.PI0023;
        const shomeiParkingCaption = commonStore.messages.PI0024;
        const log = Log.create("RoomSelect");
        //----------以下 ページネーション関連---------
        const paginationLabels = {
            rowsPerPageLabel: "ページあたりの行数",
            noPageLabel: "データが見つかりませんでした。"
        };
        //1ぺージ当たりの行数プルダウン
        const rowPerPageOptions = commonStore.mypageTableSetting.rowPerPageOptions;
        //テーブルカラム
        const columns = [
            { name: "taikyoStatus", label: "入居状況", align: "center", field: "taikyoStatus", sortable: true },
            { name: "bukkenName", label: "物件名", align: "left", field: "bukkenName", sortable: true },
            { name: "roomNumber", label: "号室", align: "left", field: "roomNumber", sortable: true },
            { name: "address", label: "住所", align: "left", field: "address", sortable: true },
            { name: "nyukyosha", label: "入居者", align: "left", field: "nyukyosha", sortable: true }
        ];
        const tableElement = ref(null);
        /** テーブル行数の更新 */
        const onUpdate = (pag) => {
            tableElement.value?.setPagination({
                page: 1,
                rowsPerPage: pag
            });
        };
        // 検索欄ViewModel + 検索欄validator
        const condition = ref(new RoomSelectFindConditionViewModel());
        const conditionValid = ref(new RoomSelectFindConditionValiator(condition.value));
        // カードレイアウトのコンポーネント用に入居契約リストをviewModelに変換する。※すでにviewmodelを受け取る仕様でコンポーネントを実装してしまった手間、変更する時間が無くこの実装になってます
        const viewModels = [];
        myPageStore.personal.nyukyokeiyakuList.forEach(x => {
            // 下記条件に当てはまる情報以外を取得
            // 状況区分が3(入居中)以外
            // かつ
            // 退去解約申請ステータスが0(入居中)
            if (isMoveIn(x.jokyoKb) || !isCurrentlyMovingIn(x.taikyoStatus)) {
                viewModels.push(new RoomSelectViewModel(x));
            }
        });
        // 表示用の検索結果オブジェクト
        const viewResults = ref([]);
        viewResults.value = [...myPageStore.personal.nyukyokeiyakuList];
        // 1ページ辺りの行数プルダウン選択時のイベント
        const pagination = ref({
            page: 1,
            rowsPerPage: 50,
            sortBy: "nyukyokeiyakuNo",
            descending: true
        });
        // ** 条件に応じて検索、条件が空ならリストごとそのまま表示 * /
        const onSearch = () => {
            viewResults.value = myPageStore.personal.nyukyokeiyakuList.filter(x => isFillted(x));
        };
        /** 対象の入居契約情報がストアにセットされている条件に一致するか判定 */
        function isFillted(nyukyokeiyaku) {
            const keyword = condition.value.keyword?.trim();
            let address = (nyukyokeiyaku.adr1 ?? "") + (nyukyokeiyaku.adr2 ?? "");
            if (!keyword) {
                return true;
            }
            return (isMatchKeyword(nyukyokeiyaku.bukkenName, keyword) || isMatchKeyword(nyukyokeiyaku.roomNumber, keyword) || isMatchKeyword(address, keyword) || isMatchKeyword(nyukyokeiyaku.nyukyosha, keyword));
        }
        /** 押下時のダイアログ関連 */
        let confirmDialog = ref(false);
        const selectedNyukyoKeiyakuNo = ref();
        const dialogNyukyokeiyaku = ref();
        function cardOrRowClick(orgNyukyokeiyakuNo) {
            selectedNyukyoKeiyakuNo.value = orgNyukyokeiyakuNo;
            confirmDialog.value = true;
            dialogNyukyokeiyaku.value = myPageStore.personal.nyukyokeiyakuList.find(x => x.orgNyukyokeiyakuNo === selectedNyukyoKeiyakuNo.value);
        }
        // 入居契約リストに駐車場契約が存在するか判定
        const hasParking = computed(() => {
            return [RoomSb.Room, RoomSb.Parking].every(n => myPageStore.personal.nyukyokeiyakuList.some(x => x.roomSb === n));
        });
        return {
            ...toRefs(myPageStore),
            myPageStore,
            columns,
            HanyoKb,
            router,
            onSearch,
            userType,
            pagination,
            rowPerPageOptions,
            paginationLabels,
            onUpdate,
            condition,
            conditionValid,
            viewResults,
            date,
            tableElement,
            viewModels,
            confirmDialog,
            cardOrRowClick,
            selectedNyukyoKeiyakuNo,
            dialogNyukyokeiyaku,
            taikyoCaption,
            taikyoParkingCaption,
            taikyoMobilCaption,
            auth,
            hasParking,
            RoomSb,
            shomeiParkingCaption,
            isMobile
        };
    }
});
